import React from 'react';

// Modal de bloqueio de login — aparece quando o backend recusa com um
// codigo estruturado (não senha errada). Dois casos hoje, mesma estrutura
// visual (overlay fixo + card branco centralizado, mesmo padrão do modal
// "Sessão encerrada em outra guia" de AuthContext.jsx):
//  - ORG_SUSPENSA: organizacoes.ativo=false (Painel de Clientes, manual ou
//    automático por inadimplência) — título/ícone padrão (sem passar props).
//  - LIMITE_SIMULTANEOS: acessos simultâneos contratados esgotados
//    (organizacoes.saas_qtd_simultaneos_ativo) — Login.jsx passa
//    titulo/mensagem/emoji próprios.
export default function ModalSuspenso({
  suporteContato, onFechar,
  emoji = '🔒',
  titulo = 'SISTEMA SUSPENSO',
  mensagem = 'Identificamos uma pendência financeira relacionada à sua licença. Entre em contato com o suporte para regularizar seu acesso.',
}) {
  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 999999, background: 'rgba(15,23,42,.72)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <div style={{
        background: '#fff', borderRadius: 10, padding: '28px 30px', maxWidth: 440,
        textAlign: 'center', boxShadow: '0 20px 50px rgba(0,0,0,.35)', fontFamily: 'inherit',
      }}>
        <div style={{ fontSize: 38, marginBottom: 10 }}>{emoji}</div>
        <div style={{ fontSize: 17, fontWeight: 800, marginBottom: 8, color: '#0f172a' }}>
          {titulo}
        </div>
        <div style={{ fontSize: 13.5, color: '#475569', marginBottom: 20, lineHeight: 1.5 }}>
          {mensagem}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {suporteContato && (
            <a
              href={suporteContato}
              target="_blank"
              rel="noreferrer"
              style={{
                background: '#16a34a', color: '#fff', border: 'none', borderRadius: 8,
                padding: '11px 22px', fontSize: 14, fontWeight: 700, cursor: 'pointer',
                textDecoration: 'none', display: 'inline-block',
              }}
            >
              FALAR COM SUPORTE
            </a>
          )}
          <button
            onClick={onFechar}
            style={{
              background: 'transparent', color: '#64748b', border: 'none',
              padding: '6px 22px', fontSize: 13, cursor: 'pointer',
            }}
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}
